(function(global) {
    'use strict';
  
    var lib = global.lib || (global.lib = {}),
        cjs = global.createjs || (global.createjs = {}),
        mms = global.mms || (global.mms = {});
    
    function Button() {
        this.__parent__.apply(this, arguments);

        this._addListeners();
    }
    Button.prototype = {
        hitAreaScale: 2,
        _addListeners: function() {
            this.on("added", this._added, this);
            this.on("mousedown", this._mousedown, this);
            this.on("pressmove", this._pressmove, this);
            this.on("pressup", this._pressup, this);
            this.on("click", this._click, this);
            this.on("click", this._sound, this);
        },
        _added: function() {
            if (!this.bounds) {
                this.bounds = this.getBounds();
                if (this.bounds) {
                    this._setHitArea();
                }
            }
        },
        _setHitArea: function() {
            var hit = new createjs.Shape();
            hit.graphics.beginFill("#000").drawCircle(this.bounds.width/2, this.bounds.height/2, this.bounds.width/2*this.hitAreaScale);
            hit.regX = this.bounds.width/2;
            hit.regY = this.bounds.height/2;
            hit.x = this.bounds.width/2;
            hit.y = this.bounds.height/2;
            //this.addChild(hit);
            this.hitArea = hit;
        },
        _mousedown: function() {
            this._scaleUp();
        },
        _pressmove: function(evt) {
            var point = this.globalToLocal(evt.stageX, evt.stageY);
            if (!this.hitArea.hitTest(point.x, point.y)) {
                this._scaleBack();
            }
            else {
                this._scaleUp();
            }
        },
        _pressup: function() {
            this._scaleBack();
        },
        _scaleUp: function() {
            this.scaleX = this.scaleY = 1.5;
            this.hitArea.scaleX = this.hitArea.scaleY = 1/1.5;
        },
        _scaleBack: function() {
            this.scaleX = this.scaleY = 1;
            this.hitArea.scaleX = this.hitArea.scaleY = 1;
        },
        _click: function() {
            throw "Button _click not implemented";
        },
        _sound: function() {
            mms.sounds.click();
        },
        _enableOrDisable: function(value) {
            this.mouseEnabled = value;
            if (mms.state.painting) {
                TweenLite.to(this, 0.5, {alpha: value ? 1 : 0});
            }
        }
    };
    
    function PaintingButton() {
        Button.apply(this, arguments);
    }
    PaintingButton.prototype = _.extend({}, Button.prototype, {
        _addListeners: function() {
            Button.prototype._addListeners.apply(this, arguments);
            
            mms.state.signals.changeButtonsEnabled.add(this._changeButtonsEnabled, this);
        },
        _changeButtonsEnabled: function(value) {
            this._enableOrDisable(value);
        }
    });
    
    var RotateButton = {
        _click: function() {
            mms.state.setRotated(!mms.state.rotated);
        }// ,
        //_sound: function() {
        //    mms.sounds.whoosh();
        //}
    };

    lib.RotateButton1 = cjs.extend2(lib.RotateButton1, PaintingButton, RotateButton);
    lib.RotateButton3 = cjs.extend2(lib.RotateButton3, PaintingButton, RotateButton);
    
    lib.UVButton = cjs.extend2(lib.UVButton, PaintingButton, {
        _click: function() {
            mms.state.setUV(true);
        }
    });
    
    lib.ZoomButton = cjs.extend2(lib.ZoomButton, PaintingButton, {
        _click: function() {
            mms.state.setZoom(true);
        }
    });
    lib.InfoButton = cjs.extend2(lib.InfoButton, PaintingButton, {
        _click: function() {
            mms.state.setInfo(true);
        }
    });
    lib.BackButton = cjs.extend2(lib.BackButton, Button, {
        hitAreaScale: 2.5,
        _addListeners: function() {
            Button.prototype._addListeners.apply(this, arguments);
            
            mms.state.signals.changeBackEnabled.add(this._changeBackEnabled, this);
        },
        // QUICK HACK
        _added: function() {
            Button.prototype._added.apply(this, arguments);
            if (!this.parent.painting) {
                mms.state.signals.changeBackEnabled.remove(this._changeBackEnabled, this);
            }
        },
        _changeBackEnabled: function(value) {
            this._enableOrDisable(value);
        },
        _click: function() {
            mms.state.goBack();
        }
    });
  
})(this);